export function requestSuccess(trabalhos) {
  return {
    type: '@trabalhos/REQUEST_SUCCESS',
    payload: { trabalhos },
  };
}
